import React, { FC } from "react";
import fallbackImage from "../../../../../prod/images/bg3.jpg";
import DOMPurify from "dompurify";
import { sanitizeOrPassthrough } from "../../helpers/rteHelpers";

interface SocialCardProps {
  imageUrl: string;
  postUrl: string;
  text: string;
}

export const SocialCard: FC<SocialCardProps> = ({
  imageUrl,
  postUrl,
  text,
}) => {
  return (
    <div className="flex-grow flex-shrink-0 pl-5 first:pl-[10px] md:first:pl-0 w-72">
      <a href={postUrl}>
        <img
          loading="lazy"
          decoding="async"
          alt="Juicer media feed image"
          className="md:size-72 size-72 aspect-square object-cover"
          src={imageUrl || fallbackImage}
        />
      </a>
      <p
        className="truncate mt-2"
        dangerouslySetInnerHTML={{
          __html: sanitizeOrPassthrough(DOMPurify, text, {
            options: { USE_PROFILES: { html: false } },
          }),
        }}
      ></p>
    </div>
  );
};
